/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IExceptionModel } from "../../models";
import * as Consts from "./consts";
import { ISetAppGlobalErrorAction, ISetDunningDialogDismissed } from "./types";

export const setAppGlobalError = (
  error?: IExceptionModel
): ISetAppGlobalErrorAction => {
  return {
    type: Consts.SET_APP_GLOBAL_ERROR,
    payload: error,
  };
};

export const setDunningDialogDismissed = (
  dismissed?: boolean
): ISetDunningDialogDismissed => {
  return {
    type: Consts.SET_DUNNING_DIALOG_DISMISSED,
    payload: dismissed,
  };
};

export const Actions = {
  setAppGlobalError,
  setDunningDialogDismissed,
};
